import React from 'react'
import { useNewTranslation } from 'hooks'
import { useSelector } from 'react-redux'
import styled from 'particles/themes/styled'
import { Header } from '../Shared'
import Fields from 'components/Shared/Fields'
import { BaseEditorContainer } from '../PredefinedTaskEditor/styles'
import { UploadType } from 'services/api/uploads'
import { selectRegistrationLengthLimits } from 'state/constants'
import { theme } from 'theme'
import { fieldIdentifiers } from 'components/Shared/Comment'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'

interface SetUpRegistrationProps {
    className?: string
    taskUuid?: string
}

const SetUpRegistration: React.FC<SetUpRegistrationProps> = ({ className, taskUuid }) => {
    const [t] = useNewTranslation()
    const settings = useSelector(selectRegistrationLengthLimits)
    return (
        <BaseEditorContainer className={className}>
            <Header
                title={t('campaignEditor.createTask.setUpRegistrationPageTitle')}
                subtitle={t('campaignEditor.createTask.setUpRegistrationPageSubtitle')}
            />
            <div className="title-input-field">
                <CampaignEditorInputFieldContainer>
                    <Fields.TextInputField
                        className={'input-area'}
                        name="title"
                        showInputLength
                        maxInputLength={settings.registration_form.title}
                        placeholder={t('campaignEditor.createTask.enterTitleHeader')}
                        label={t('campaignEditor.createTask.enterTitleHeader')}
                        isRequired
                        width="100%"
                        identifier={`${taskUuid}_${fieldIdentifiers.setupTitle}`}
                    />
                    <Fields.TextAreaField
                        name="description"
                        label={t('campaignEditor.createTask.enterDescriptionHeader')}
                        subtext={t('campaignEditor.createTask.enterDescriptionRegistrationSubtext')}
                        maxInputLength={settings.registration_form.description}
                        showInputLength
                        width="100%"
                        isRequired
                        minTextAreaHeight={112}
                        identifier={`${taskUuid}_${fieldIdentifiers.setupDescription}`}
                    />
                    <Fields.ImageUploadField
                        name="images"
                        title={t('campaignEditor.createTask.uploadFilesExampleHeader')}
                        subtitle={t('campaignEditor.createTask.uploadFileRegistrationSubtext')}
                        presetType={UploadType.CAMPAIGN}
                        maxFiles={1}
                        uploadContainerWidth="594px"
                        identifier={`${taskUuid}_${fieldIdentifiers.setupImages}`}
                    />
                </CampaignEditorInputFieldContainer>
            </div>
        </BaseEditorContainer>
    )
}

export default styled(SetUpRegistration)`
    min-height: 100%;
    height: fit-content;

    .title-input-field {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.l};
    }
`
